export enum ColorSpace {
    Linear = 0,
    Srgb = 1,
}

// Computing sRGB transformations directly is very expensive, so we've
// pre-computed them into these lookup tables.
// Thanks to Webpack, and Safari being bad at optimizing across anonymous
// function boundaries, we also can't store conversion to linear values here.
// Instead, go look in grayscale.ts.

const linearSrgbMapping: number[] = [
    0,
    13,
    22,
    28,
    34,
    38,
    42,
    46,
    50,
    53,
    56,
    59,
    61,
    64,
    66,
    69,
    71,
    73,
    75,
    77,
    79,
    81,
    83,
    85,
    86,
    88,
    90,
    92,
    93,
    95,
    96,
    98,
    99,
    101,
    102,
    104,
    105,
    106,
    108,
    109,
    110,
    112,
    113,
    114,
    115,
    117,
    118,
    119,
    120,
    121,
    122,
    124,
    125,
    126,
    127,
    128,
    129,
    130,
    131,
    132,
    133,
    134,
    135,
    136,
    137,
    138,
    139,
    140,
    141,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    148,
    149,
    150,
    151,
    152,
    153,
    154,
    155,
    155,
    156,
    157,
    158,
    159,
    159,
    160,
    161,
    162,
    163,
    163,
    164,
    165,
    166,
    167,
    167,
    168,
    169,
    170,
    170,
    171,
    172,
    173,
    173,
    174,
    175,
    175,
    176,
    177,
    178,
    178,
    179,
    180,
    180,
    181,
    182,
    182,
    183,
    184,
    185,
    185,
    186,
    187,
    187,
    188,
    189,
    189,
    190,
    190,
    191,
    192,
    192,
    193,
    194,
    194,
    195,
    196,
    196,
    197,
    197,
    198,
    199,
    199,
    200,
    200,
    201,
    202,
    202,
    203,
    203,
    204,
    205,
    205,
    206,
    206,
    207,
    208,
    208,
    209,
    209,
    210,
    210,
    211,
    212,
    212,
    213,
    213,
    214,
    214,
    215,
    215,
    216,
    216,
    217,
    218,
    218,
    219,
    219,
    220,
    220,
    221,
    221,
    222,
    222,
    223,
    223,
    224,
    224,
    225,
    226,
    226,
    227,
    227,
    228,
    228,
    229,
    229,
    230,
    230,
    231,
    231,
    232,
    232,
    233,
    233,
    234,
    234,
    235,
    235,
    236,
    236,
    237,
    237,
    238,
    238,
    238,
    239,
    239,
    240,
    240,
    241,
    241,
    242,
    242,
    243,
    243,
    244,
    244,
    245,
    245,
    246,
    246,
    246,
    247,
    247,
    248,
    248,
    249,
    249,
    250,
    250,
    251,
    251,
    251,
    252,
    252,
    253,
    253,
    254,
    254,
    255,
    255,
];

export function convertFromLinear(colorSpace: ColorSpace, value: number): number {
    switch (colorSpace) {
        case ColorSpace.Linear:
            return value;
        case ColorSpace.Srgb:
            return linearSrgbMapping[value];
    }
}
